import { all } from 'redux-saga/effects';
import storyDetailsSaga from './../pages/ViewerPage/saga';

export default function* createRootSaga() {
  yield all([storyDetailsSaga()]);
}
